<template>
  <div class="energy-input">
    <a-input
        type="number"
        v-model="stateValue"
        v-bind:placeholder="placeholder"
        v-on:change="onChange"
        suffix="kWh"
    ></a-input>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "EnergyComponent",
  model: {
    prop: 'value',
    event: 'change.value'
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      default: '',
    },
  },
  data() {
    return {
      stateValue: this.value,
    };
  },
  watch: {
    value: function value(val) {
      this.stateValue = parseInt(val);
    }
  },
  mounted() {
  },
  methods: {
    onChange: function onChange(e) {
      this.$emit('change.value', parseInt(e.target.value));
      this.$emit('change', e);
      this.$emit('input', e);
    },
  }
}
</script>

<style scoped>
</style>
